// extracted by mini-css-extract-plugin
module.exports = {"list":"FeedList_list__1gLHJ"};